import { render } from "./ParagraphComponent.vue?vue&type=template&id=2f97ce08"
import script from "./ParagraphComponent.vue?vue&type=script&lang=js"
export * from "./ParagraphComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__